module.exports = __webpack_public_path__ + "static/media/031.88470013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/031.jpg
// module id = 538
// module chunks = 0